module.exports = __webpack_public_path__ + "media/images/icons/bank-6f9e78a201541e39e941e5fa4e7710b9.svg";